import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';

import IMAGES from 'shared/constants/images';
import Button from 'shared/modules/common/components/atoms/Button';

type Props = {
  onPress: () => void;
};

const ReSignIn = (props: Props) => {
  return (
    <View style={style.root}>
      <View>
        <Text style={[style.text, style.title]}>再ログインしてください</Text>
        <Text style={style.text}>
          メールアドレスを変更した場合は、現在ご登録のメールアドレスでログイン後、アカウント情報にてご変更いただけます。
          携帯電話番号を変更した場合には下記のリンクから変更手続きを行ってください。
        </Text>
      </View>
      <Image source={{ uri: IMAGES.return }} style={style.image} />
      <Button
        title="再ログインする"
        onPress={props.onPress}
        id="back-to-signin-button"
      />
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'space-between',
  },
  text: {
    marginBottom: 8,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  image: {
    width: 100,
    height: 100,
    alignSelf: 'center',
  },
});

export default ReSignIn;
